(function () {
  'use strict';
  if (window.__merlonsCompleteFacets) return;
  window.__merlonsCompleteFacets = true;
  var generation = 0;
  var controller = null;
  var requested = false;
  var loading = false;
  var refreshedAt = 0;
  var expandedParams = new Set();
  var inputFocus = null;
  // Labels only, never cached products/counts: keep a removable selection
  // recognizable when another filter temporarily leaves it with zero matches.
  var knownLabels = new Map();
  var prefix = 'filter.p.m.merlons_catalog.filter_';
  var keys = window.MerlonsFilterIndex.GROUPS;
  var language = (document.documentElement.lang || 'ka').split('-')[0];
  var copy = {
    ka: { loading: 'ფილტრების სრული სია იტვირთება…', error: 'სრული სია ვერ ჩაიტვირთა. სცადეთ ხელახლა.', retry: 'ხელახლა ცდა', clear: 'გასუფთავება', selected: 'არჩეული მნიშვნელობა' },
    en: { loading: 'Loading the complete filter list…', error: 'The complete list could not load. Please try again.', retry: 'Try again', clear: 'Clear', selected: 'Selected value' },
    ru: { loading: 'Загружаем полный список фильтров…', error: 'Не удалось загрузить полный список. Попробуйте ещё раз.', retry: 'Повторить', clear: 'Сбросить', selected: 'Выбранное значение' }
  };
  var labels = copy[language] || copy.ka;
  function root() { return document.getElementById('main-collection-filters'); }
  function form() { return document.getElementById('CollectionFiltersForm'); }
  function isReference(name) { return keys.some(function (key) { return name === prefix + key + '_reference'; }); }
  function labelKey(name, value) { return name + '|' + value; }
  function mountingValueRank(value) {
    var label = String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var isUnder = label.indexOf('ქვემოდან') !== -1 ||
      label.indexOf('ამოსაკრავი') !== -1 ||
      label.indexOf('ამოსმადი') !== -1 ||
      label.indexOf('undermount') !== -1 ||
      label.indexOf('нижний') !== -1;
    var isTop = label.indexOf('ზემოდან') !== -1 ||
      label.indexOf('ჩასასმელი') !== -1 ||
      label.indexOf('topmount') !== -1 ||
      label.indexOf('верхний') !== -1;
    if (isUnder && !isTop) return 0;
    if (isTop && !isUnder) return 1;
    if (isUnder && isTop) return 2;
    return 99;
  }
  function orderedValues(filter) {
    var values = filter.values.slice();
    if (filter.key !== 'mounting_type') return values;
    return values.map(function (value, index) {
      return { value: value, rank: mountingValueRank(value.label), index: index };
    }).sort(function (left, right) {
      return left.rank - right.rank || left.index - right.index;
    }).map(function (entry) { return entry.value; });
  }
  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function referenceGroups() {
    var current = form();
    return current ? Array.from(current.querySelectorAll('.js-filter')).filter(function (group) {
      return isReference(group.dataset.filterParam || '') || Array.from(group.querySelectorAll('input[name]')).some(function (input) { return isReference(input.name); });
    }) : [];
  }
  function status(message, failed) {
    var current = form();
    if (!current) return;
    var node = current.querySelector('[data-merlons-complete-filter-status]');
    if (!node) {
      node = element('div', 'merlons-complete-filter-status');
      node.dataset.merlonsCompleteFilterStatus = '';
      var live = element('span');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      node.appendChild(live);
      var retry = element('button', 'btn', labels.retry);
      retry.type = 'button';
      retry.dataset.merlonsFilterRetry = '';
      node.appendChild(retry);
      current.prepend(node);
    }
    node.querySelector('span').textContent = message;
    node.querySelector('button').hidden = !failed;
    node.hidden = !message;
  }
  function clearHref(params, name, value) {
    var next = new URLSearchParams(params);
    next.delete(name);
    if (value != null) params.getAll(name).flatMap(function (entry) { return entry.split(','); }).forEach(function (entry) { if (entry !== value) next.append(name, entry); });
    next.delete('page');
    return window.location.pathname + (next.size ? '?' + next.toString() : '');
  }
  function addReset(parent, href, text, className) {
    var reset = element('facet-remove');
    var link = element('a', className, text);
    link.href = href;
    reset.appendChild(link);
    parent.appendChild(reset);
  }
  function checkbox(list, filter, value) {
    var item = element('li', 'list-menu__item facets__item' + (filter.key === 'color' ? ' facet-color-text' : filter.key === 'size' ? ' facet-size' : ''));
    var label = element('label', 'facet-checkbox pointer d-flex align-items-center');
    var input = element('input');
    input.type = 'checkbox';
    input.name = filter.paramName;
    input.value = value.id;
    input.id = 'MerlonsComplete-' + filter.key + '-' + value.id.replace(/[^a-z0-9]/gi, '-');
    input.checked = value.active;
    input.setAttribute('aria-label', filter.label + ': ' + value.label + ' (' + value.count + ')');
    label.htmlFor = input.id;
    label.title = value.label;
    var check = element('span', 'custom-checkbox');
    check.setAttribute('aria-hidden', 'true');
    // Fixed decorative markup only; labels and IDs always use text/DOM attributes.
    check.innerHTML = '<svg class="merlons-icon merlons-icon--check" viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="m5 12 4 4L19 6" stroke="currentColor" stroke-width="2"/></svg>';
    var count = element('span', 'value_count', '(' + value.count + ')');
    count.setAttribute('aria-hidden', 'true');
    label.append(input, check, element('span', 'filter-option-value', value.label), count);
    item.appendChild(label);
    list.appendChild(item);
  }
  function group(filter, params, expanded) {
    var values = orderedValues(filter);
    var node = element('div', 'js-filter');
    node.dataset.index = 'merlons-complete-' + filter.key;
    node.dataset.filterParam = filter.paramName;
    node.dataset.merlonsCompleteFacet = '';
    if (filter.key === 'color' || filter.key === 'size') node.dataset.filterKind = filter.key;
    else if (filter.key === 'mounting_type') node.dataset.filterKind = 'mounting';
    var heading = element('div', 'facets__label position-relative' + (expanded ? ' act' : ''));
    var toggle = element('button', 'facets__label--title');
    toggle.type = 'button';
    toggle.appendChild(element('span', '', filter.label));
    var chevron = element('span');
    chevron.innerHTML = '<svg class="facets__label-chevron" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="m5.5 7.5 4.5 4.5 4.5-4.5"/></svg>';
    toggle.appendChild(chevron.firstChild);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var content = element('div', 'facets__content');
    content.id = 'MerlonsCompleteContent-' + filter.key;
    toggle.setAttribute('aria-controls', content.id);
    content.style.display = expanded ? 'block' : 'none';
    heading.appendChild(toggle);
    addReset(heading, clearHref(params, filter.paramName), labels.clear, 'facets__reset');
    var fieldset = element('fieldset', 'facets__fieldset');
    fieldset.appendChild(element('legend', 'merlons-visually-hidden', filter.label));
    var list = element('ul', 'facets__list list-unstyled' + (filter.key === 'color' ? ' facets__list-color' : filter.key === 'size' ? ' facets__list-size' : ''));
    list.setAttribute('role', 'list');
    values.filter(function (value) { return value.count > 0; }).forEach(function (value) { checkbox(list, filter, value); });
    // Active zero-result choices remain removable and in FormData, but are not usable options.
    values.filter(function (value) { return value.active && value.count === 0; }).forEach(function (value) {
      var hidden = element('input');
      hidden.type = 'hidden'; hidden.name = filter.paramName; hidden.value = value.id;
      node.appendChild(hidden);
    });
    fieldset.appendChild(list);
    content.appendChild(fieldset);
    node.append(heading, content);
    node.hidden = !list.children.length;
    return node;
  }
  function activeChips(filters, params) {
    var canonical = document.querySelectorAll('[data-merlons-active-facets-results]');
    var containers = canonical.length ? canonical : document.querySelectorAll('.facets-remove-all');
    function signature(href) {
      var params = new URL(href, window.location.origin).searchParams;
      return Array.from(params.entries()).filter(function (entry) { return entry[0].startsWith('filter.') || entry[0] === 'merlons_offer'; }).sort().map(function (entry) { return entry.join('='); }).join('&');
    }
    containers.forEach(function (container) {
      container.querySelectorAll('[data-merlons-complete-chip]').forEach(function (chip) { chip.remove(); });
      filters.forEach(function (filter) {
        filter.values.filter(function (value) { return value.active; }).forEach(function (value) {
          var href = clearHref(params, filter.paramName, value.id);
          var already = Array.from(container.querySelectorAll('a[href]')).some(function (link) {
            return !link.closest('.btn--clear--all') && signature(link.href) === signature(href);
          });
          if (already) return;
          var chip = element('facet-remove', 'btn--clear--item');
          chip.dataset.merlonsCompleteChip = '';
          var link = element('a', 'active-facets__button position-relative d-flex align-items-center', filter.label + ': ' + value.label + ' ×');
          link.href = href;
          chip.appendChild(link); container.appendChild(chip);
        });
      });
    });
  }
  function render(result, params) {
    var current = form();
    var currentRoot = root();
    if (!current || !currentRoot) return;
    var expanded = expandedParams;
    var focused = document.activeElement;
    var focus = focused && focused.name ? {name: focused.name, value: focused.value} : inputFocus;
    inputFocus = null;
    result.filters.forEach(function (filter) {
      filter.values.forEach(function (value) {
        var key = labelKey(filter.paramName, value.id);
        if (value.label) { knownLabels.set(key, value.label); return; }
        var old = Array.from(current.querySelectorAll('input')).find(function (input) { return input.name === filter.paramName && input.value === value.id; });
        var oldLabel = old && old.closest('label');
        var text = oldLabel && oldLabel.querySelector('.filter-option-value');
        value.label = (text && text.textContent) || knownLabels.get(key) || labels.selected;
      });
    });
    referenceGroups().forEach(function (node) {
      var input = node.querySelector('input[name]');
      var param = node.dataset.filterParam || (input && input.name);
      if (node.querySelector('.facets__label.act, [aria-expanded="true"]')) expanded.add(param);
      node.remove();
    });
    var wrapper = current.querySelector('.CollecttionFilterWrapper');
    result.filters.forEach(function (filter) { wrapper.appendChild(group(filter, params, expanded.has(filter.paramName))); });
    currentRoot.dataset.merlonsCompleteFacets = 'true';
    activeChips(result.filters, params);
    if (focus) {
      var replacement = Array.from(current.querySelectorAll('input')).find(function (input) { return input.name === focus.name && input.value === focus.value && input.type !== 'hidden'; });
      if (replacement && !replacement.closest('[hidden]')) replacement.focus({preventScroll:true});
    }
  }
  function options(params, signal) {
    var current = root();
    var sources = typeof window.merlonsGetCollectionCategorySources === 'function' ? window.merlonsGetCollectionCategorySources() : [{url: window.location.pathname}];
    var handles = sources.map(function (source) { return source.handle; }).filter(Boolean);
    var query = (params.get('q') || '').trim();
    var isSearch = current.classList.contains('page-search') || Boolean(query);
    var all = current.dataset.merlonsCollectionHandle === 'all' || current.classList.contains('page-search');
    var urls = sources.map(function (source) { return source.url; });
    var scoped = null;
    if (isSearch) {
      urls = [current.dataset.merlonsSearchPath || '/search'];
      if (!all) scoped = handles;
      params.set('options[prefix]', 'last');
    } else if (sources.length > 6) {
      urls = [current.dataset.merlonsAllProductsPath || ((language === 'ka' ? '' : '/' + language) + '/collections/all')];
      scoped = handles;
    }
    return {sourceURLs: urls, context: params, scopeHandles: scoped, search: isSearch, signal: signal};
  }
  function renderAvailability(data, params) {
    var selected = window.MerlonsFilterIndex.select(data.products, data.filters, params);
    form().querySelectorAll('input[name="filter.v.availability"]').forEach(function (input) {
      var available = input.value === '1';
      var count = selected.filter(function (product) { return product.available === available; }).length;
      var label = input.closest('label');
      var value = label && label.querySelector('.value_count');
      if (value) value.textContent = '(' + count + ')';
      input.setAttribute('aria-label', (input.getAttribute('aria-label') || '').replace(/\(\d+\)$/, '(' + count + ')'));
      input.disabled = count === 0 && !input.checked;
      input.setAttribute('aria-disabled', String(input.disabled));
      if (label) label.classList.toggle('facet-checkbox--disabled', input.disabled);
      var item = input.closest('li');
      if (item) item.classList.toggle('is-disabled', input.disabled);
    });
  }
  function refresh() {
    if (!requested || !root() || !form() || !window.MerlonsFilterIndex) return;
    var ticket = ++generation;
    if (controller) controller.abort();
    controller = new AbortController();
    var currentRoot = root();
    var params = new URLSearchParams(window.location.search);
    var state = window.location.pathname + window.location.search;
    var requestOptions = options(new URLSearchParams(params), controller.signal);
    var startedAt = Date.now();
    var freshness = window.MerlonsFilterFreshness;
    var sourceKey = freshness ? freshness.fingerprint(requestOptions, params, window.location.pathname) : '';
    loading = true;
    status(labels.loading, false);
    form().setAttribute('aria-busy', 'true');
    window.MerlonsFilterIndex.load(requestOptions).then(function (data) {
      var availability = Promise.resolve(data);
      if (window.MerlonsFilterIndex.hasReferences(params) && params.has('filter.v.availability')) {
        var availabilityParams = new URLSearchParams(params);
        availabilityParams.delete('filter.v.availability');
        availability = window.MerlonsFilterIndex.load(options(availabilityParams, controller.signal));
      }
      var verificationOptions = Object.assign({}, requestOptions, {timeoutMs:Math.max(1,25000 - (Date.now() - startedAt))});
      return Promise.all([availability, freshness ? freshness.verify(data, verificationOptions, params) : null]).then(function (values) { return {data:data, availability:values[0], proof:values[1]}; });
    }).then(function (loaded) {
      if (ticket !== generation || currentRoot !== root() || state !== window.location.pathname + window.location.search) return;
      if (freshness && sourceKey !== freshness.fingerprint(options(new URLSearchParams(params), controller.signal),params,window.location.pathname)) return;
      // Publish the facet snapshot and its result-state decision together. Never
      // put fresh counts beside a grid that is already proven stale.
      if (freshness) freshness.commit(loaded.proof);
      render(window.MerlonsFilterIndex.count(loaded.data.products, loaded.data.filters, params), params);
      if (window.MerlonsFilterIndex.hasReferences(params)) renderAvailability(loaded.availability, params);
      refreshedAt = Date.now();
      status('', false);
    }).catch(function (error) {
      if (ticket !== generation || error.name === 'AbortError') return;
      if (freshness) freshness.fail();
      status(labels.error, true);
      console.warn('[Merlons complete filters]', error.message);
    }).finally(function () {
      if (ticket !== generation) return;
      loading = false;
      if (form()) form().removeAttribute('aria-busy');
    });
  }
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('#CollectionFiltersForm .facets__label--title');
    if (toggle) {
      var selectedGroup = toggle.closest('.js-filter');
      var selectedParam = selectedGroup.dataset.filterParam || selectedGroup.querySelector('input[name]')?.name;
      if (isReference(selectedParam || '')) window.setTimeout(function () {
        if (!selectedGroup.isConnected) return;
        if (selectedGroup.querySelector('.facets__label.act')) expandedParams.add(selectedParam);
        else expandedParams.delete(selectedParam);
      }, 0);
    }
    if (event.target.closest('[data-merlons-filter-trigger], [data-toggle="FilterSidebar"], [data-merlons-filter-retry]')) {
      requested = true;
      // Each deliberate reopen revalidates; no background polling.
      refresh();
    }
  });
  document.addEventListener('merlons:filters:request', function (event) {
    generation += 1;
    if (controller) controller.abort();
    loading = false;
    if (window.MerlonsFilterFreshness && window.MerlonsFilterFreshness.hasReferences(new URLSearchParams(window.location.search))) requested = true;
    if (requested) {
      status(labels.loading, false);
      if (event.detail && event.detail.offerOnly) refresh();
    }
  });
  document.addEventListener('input', function (event) {
    if (!requested || !event.target.closest('#CollectionFiltersForm') || !event.target.name) return;
    // An in-flight response must not erase a selection waiting for the native debounce.
    generation += 1;
    if (controller) controller.abort();
    loading = false;
    if (isReference(event.target.name)) {
      inputFocus = {name:event.target.name,value:event.target.value};
      expandedParams.add(event.target.name);
    }
  }, true);
  document.addEventListener('merlons:collection:rendered', function () {
    if (requested) refresh();
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted && requested) refresh(); });
  document.addEventListener('visibilitychange', function () {
    // Revalidate on the next deliberate open, without rebuilding controls under
    // the pointer when focus returns from another tab or application.
    if (!document.hidden) refreshedAt = 0;
  });
  function start() {
    var current = root();
    if (!current || !form()) return;
    // Non-drawer layouts have visible filters immediately.
    if (!current.querySelector('[data-merlons-filter-sheet]') || (window.MerlonsFilterFreshness && window.MerlonsFilterFreshness.hasReferences(new URLSearchParams(window.location.search)))) { requested = true; refresh(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
}());
